export class environment {
  public static dev = () => window.location.host == 'localhost:4201';
}
